export default {
  placeholder: 'Wybierz źródło danych',
};
